// extracted by mini-css-extract-plugin
module.exports = {"vWhite":"#fff","preloader":"Preloader__preloader___Wblnw"};